// Vendor Libs
import {get} from 'lodash';
import servicesFormConfig from '../../config/services-form-config';

const displayPathMiddleware = (store) => (next) => (action) => {
    const {dispatch, getState} = store;
    next(action);
    const nextState = getState();
    const actions = {
        SET_PRIORITY: () => updatePriority(dispatch, action, nextState),
        SET_PRIORITY_ON_DRAG: () => updatePriorityOnDrag(dispatch, action, nextState),
    };

    if (actions[action.type]) {
        return actions[action.type]();
    }
};

function updatePriority(dispatch, {formName, priorityRank, networkDisplayPathModifierId}, nextState) {
    const {servicesSearchData, formData} = nextState;

    const searchValue = get(
        get(servicesSearchData, [get(servicesFormConfig, [formName, 'providerServiceDataKey'])], {}),
        'searchData.content.0',
        {}
    );

    const allSearchData = get(servicesSearchData, `${formName}.searchData.content`, []);
    const displayPathModifierFormValues = get(formData, `${formName}.values`, {});
    const priorityOfAllDisplayPathModifiers = allSearchData.map((obj) => obj.priority);

    const modifiedFormValue = {...displayPathModifierFormValues};
    modifiedFormValue.method = searchValue.method;
    modifiedFormValue.match = searchValue.match;
    modifiedFormValue.transformation = searchValue.transformation;

    if (priorityRank === 'highest') {
        modifiedFormValue.priority = Math.min(...priorityOfAllDisplayPathModifiers);
    } else if (priorityRank === 'lowest') {
        modifiedFormValue.priority = Math.max(...priorityOfAllDisplayPathModifiers);
    }

    updateFormData(dispatch, formName, modifiedFormValue, displayPathModifierFormValues, networkDisplayPathModifierId);
}

function updatePriorityOnDrag(dispatch, {destination, formName, source}, nextState) {
    const {servicesSearchData, formData} = nextState;

    const allSearchData = get(servicesSearchData, `${formName}.searchData.content`, []);
    const displayPathModifierFormValues = get(formData, `${formName}.values`, {});

    const {match, method, networkDisplayPathModifierId, transformation} = allSearchData[source.index];

    const modifiedFormValue = {...displayPathModifierFormValues};
    modifiedFormValue.method = method;
    modifiedFormValue.match = match;
    modifiedFormValue.transformation = transformation;
    modifiedFormValue.priority = parseInt(allSearchData[destination.index].priority);

    updateFormData(dispatch, formName, modifiedFormValue, displayPathModifierFormValues, networkDisplayPathModifierId);
}

function updateFormData(dispatch, formName, modifiedFormValue, originalFormValues, customPathId) {
    dispatch({
        type: 'FORM_SET_FIELD_VALUES',
        formName,
        resetValues: true,
        values: modifiedFormValue,
    });

    dispatch({
        type: 'SET_FORM_CUSTOM_PATH',
        formName,
        customPath: customPathId,
    });

    dispatch({
        type: 'FORM_SUBMIT_FETCH',
        formName,
    });

    dispatch({
        type: 'FORM_SET_FIELD_VALUES',
        formName,
        resetValues: true,
        values: originalFormValues,
    });
}

export default displayPathMiddleware;
